export const gloriafood = {
  seo: {
    title: 'Gloriafood is shutting down? Switch to Bistroo for free',
    description:
      'Gloriafood ends all services on April 30, 2027. Switch to Bistroo now: free until May 1, 2027 and your own webshop live in under 30 minutes.',
  },
  hero: {
    badge: 'Important for Gloriafood restaurants',
    title_1: 'Gloriafood is shutting down.',
    title_em: 'Your new home is ready.',
    subtitle:
      'Gloriafood ends all of its services on April 30, 2027. Thousands of restaurants will need a new ordering solution. Bistroo is ready for you, and until that day you pay nothing.',
    offer_pt1: 'Free subscription up to and including',
    offer_date: 'April 30, 2027',
    offer_pt2: ', the day Gloriafood goes dark.',
    cta_primary: 'Create my webshop, for free',
    cta_secondary: 'Talk to our team',
    reassurance: 'No credit card needed. Live in under 30 minutes. Cancel monthly.',
  },
  countdown: {
    label: 'Time remaining until Gloriafood shuts down',
    units: {
      months: 'months',
      days: 'days',
      hours: 'hours',
      minutes: 'minutes',
    },
    cta_text: 'Every day you wait is a day closer to a webshop that goes offline.',
    cta_link: 'Switch today',
  },
  trust: {
    items: [
      { icon: 'bi-lightning-charge-fill', text: 'Live in under 30 minutes' },
      { icon: 'bi-credit-card-2-front-fill', text: 'No setup costs' },
      { icon: 'bi-unlock-fill', text: 'No long-term contract' },
      { icon: 'bi-headset', text: 'Personal help with your switch' },
    ],
  },
  timeline: {
    kicker: "What's happening",
    heading: 'The clock is ticking for Gloriafood restaurants',
    lead: "Here's what you need to know, and what to do next.",
    items: [
      {
        icon: 'bi-megaphone-fill',
        date: 'Now',
        title: 'Gloriafood announces its wind-down',
        text: 'Gloriafood has announced it will cease all of its services. That means thousands of restaurants have to find a new solution for online ordering.',
      },
      {
        icon: 'bi-exclamation-triangle-fill',
        date: 'April 30, 2027',
        title: 'The Gloriafood servers go dark',
        text: 'Every webshop, website and ordering page running on Gloriafood stops working. No more orders, no more revenue.',
      },
      {
        icon: 'bi-check-circle-fill',
        date: 'Today',
        title: 'Switch to Bistroo at no cost',
        text: 'Sign up now and use your full Bistroo webshop free of charge until April 30, 2027. That way you switch at your own pace, without rushing and without paying twice.',
      },
    ],
  },
  why: {
    kicker: 'The right choice',
    heading: 'Why Bistroo is the logical alternative',
    lead: 'Not just another webshop tool. Bistroo is built from the ground up for restaurants like yours.',
    items: [
      {
        title: 'Your webshop is entirely yours',
        text: 'Your brand, your domain, your guest data. There is no marketplace standing between you and your guests: orders, revenue and relationships stay with you.',
      },
      {
        title: 'Next-gen design, ready to go',
        text: 'Bistroo webshops genuinely look modern. With customisable templates your webshop shows off the quality of your food, instead of a generic ordering page from 2015.',
      },
      {
        title: 'A complete suite at an accessible price',
        text: 'Webshop, website, QR ordering, kiosk and POS all belong to the same ecosystem. One monthly subscription, transparent rates, everything managed in the Bistroo Manager.',
      },
      {
        title: 'A partner, not a supplier',
        text: 'Bistroo can be cancelled monthly, because we want to earn your trust again every single month. No lock-in and no surprises afterwards.',
      },
    ],
  },
  features: {
    kicker: 'Why Bistroo',
    heading: 'Everything you had with Gloriafood, and more',
    lead: 'Purpose-built for quick-service, take-away and delivery. Not an afterthought, but exactly what our software is made for.',
    items: [
      {
        icon: 'bi-shop',
        title: 'A webshop in your own brand style',
        text: 'Your own domain, your own colours and customisable templates. Guests order directly from you, not through a marketplace.',
      },
      {
        icon: 'bi-phone',
        title: 'Full order management',
        text: 'Accept, manage and track every order in real time in the Bistroo Manager. Adjust menus, opening hours and prices yourself, instantly.',
      },
      {
        icon: 'bi-cash-coin',
        title: 'Transparent, fair rates',
        text: 'A monthly subscription without surprises. You always know where you stand and your guest data stays yours.',
      },
      {
        icon: 'bi-lightning-charge',
        title: 'Self-service, plug & play',
        text: 'No developer needed. Build your menu, connect your payouts through Stripe and go live, all within 30 minutes.',
      },
      {
        icon: 'bi-globe-europe-africa',
        title: 'Growing with you across Europe',
        text: 'Active in the Netherlands and Belgium, and in Germany later in 2026. Built to grow along with your ambitions.',
      },
      {
        icon: 'bi-headset',
        title: 'Personal customer service',
        text: 'A real team that picks up. We are there when it is busiest and when it matters most.',
      },
    ],
  },
  offer: {
    heading: "Free until Gloriafood's last day.",
    text: 'Switch now and pay nothing until May 1, 2027. Your subscription only starts the moment Gloriafood stops, not before.',
    button: 'Claim your free period',
    note: '* The offer applies to the standard Bistroo Webshop subscription, for restaurants switching from Gloriafood before April 30, 2027.',
  },
  steps: {
    kicker: 'In 3 steps',
    heading: 'Online in under 30 minutes',
    items: [
      {
        title: 'Create your free account',
        text: 'Sign up at merchant.bistroo.nl. No credit card, no commitment. Done in 2 minutes.',
      },
      {
        title: 'Set up your menu and webshop',
        text: 'Enter your menu, pick a template and set your domain and opening hours. All by yourself, in the Bistroo Manager.',
      },
      {
        title: 'Go live and take orders',
        text: 'Connect Stripe for your payouts, publish your webshop and share your link or QR code with your guests.',
      },
    ],
    button: 'Start my free webshop',
  },
  contact: {
    kicker: 'Talk to our team',
    heading: 'Prefer a personal introduction?',
    lead: 'Leave your details and one of our restaurant specialists will get in touch within one business day to walk you through the switch. At no cost.',
    perks: [
      'We help you move your menu over from Gloriafood',
      'Free help setting up your webshop design',
      'No subscription costs until May 1, 2027',
      'Cancel monthly, no long-term contract',
    ],
    card: {
      title: 'Request your switch',
      text: 'Fill in the contact form and we will get back to you within one business day. Prefer to explore on your own first? Create your free account right away.',
      button: 'Go to the contact form',
      secondary: 'Create a free account now',
      disclaimer: 'We reply within one business day. No spam, ever.',
    },
  },
  faq: {
    title_pt1: 'Frequently asked questions about',
    title_pt2: 'switching over',
    items: [
      {
        q: 'How does the free period work exactly?',
        a: 'Sign up before April 30, 2027 and let us know you are switching from Gloriafood. We activate your account with no subscription costs until May 1, 2027. After that the standard monthly subscription applies, which you can cancel every month.',
      },
      {
        q: 'Can I bring my menu over from Gloriafood?',
        a: 'Yes. Get in touch with our team and we will help you move it across. Rather do it yourself? The menu builder in the Bistroo Manager lets you set up your categories, options, photos and prices quickly.',
      },
      {
        q: 'Do I need technical skills to switch?',
        a: 'No. Bistroo is fully self-service: the Bistroo Manager is built so that you, as a restaurant owner, set up and manage everything yourself, without a developer. If you do get stuck, our support team helps you personally.',
      },
      {
        q: 'What happens after the free period?',
        a: "From May 1, 2027 you move to Bistroo's standard monthly subscription. You can change or cancel at any time; we do not work with long-term contracts.",
      },
      {
        q: 'Is Bistroo available in my country?',
        a: 'Bistroo is live in the Netherlands and Belgium, and we are launching in Germany later in 2026. Based elsewhere? Get in touch and we will keep you posted on our expansion.',
      },
    ],
  },
  cta: {
    heading_1: "Don't wait until the lights go out.",
    heading_em: 'Switch today.',
    text: '30 minutes to set up. Free until Gloriafood stops. No risk.',
    button_primary: 'Start my free webshop',
    button_secondary: 'Get in touch',
  },
}
